var exports = {
  "P": "IconButton_0__qp3kMY",
};

module.exports = exports;
